// extracted by mini-css-extract-plugin
export default {"circleNumber":"CircleNumber_circleNumber__fRzso","number":"CircleNumber_number__q2jRs"};